import { render, staticRenderFns } from "./FixedAssetInternalView.vue?vue&type=template&id=0c2babc0"
import script from "./FixedAssetInternalView.vue?vue&type=script&lang=js"
export * from "./FixedAssetInternalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports